<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  async mounted() {},
};
</script>
